<!--
  功能：持仓股列表
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：2025-07-14 10:08:33
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div class="content">
    <div class="top-optipon">
      <!-- 搜索框 -->
      <van-search
        v-model="searchValue"
        @input="searchInput()"
        @clear="initSearchCond()"
        placeholder="请输入股票名称/代码/拼音"
        class="search-info"
      >
        <template #left-icon>
          <img src="@/assets/image/hedging/search.png" alt="" srcset="" class="search-img" />
        </template>
      </van-search>

      <!-- 搜索内容 -->
      <div v-if="searchList.length === 0">
        <div class="select-conent" v-show="selectShow">
          <!-- 行情数据 -->
          <div class="select-hq">
            <span class="select-hq-text">最新价: </span>
            <span
              :class="[
                judgeColor(
                  stockHq[0]
                    ? stockHq[0].JieSuanZhangFu
                      ? stockHq[0].JieSuanZhangFu
                      : stockHq[0].ZhangFu
                    : 0
                )
              ]"
              >{{ stockHq[0] ? stockHq[0].ZuiXinJia : '--' }}</span
            >
            <span
              :class="[
                judgeColor(
                  stockHq[0]
                    ? stockHq[0].JieSuanZhangDie
                      ? stockHq[0].JieSuanZhangDie
                      : stockHq[0].ZhangDie
                    : 0
                )
              ]"
              >{{ stockHq[0] ? formatZhangDie(stockHq[0]) : '--' }}</span
            >
            <span
              :class="[
                judgeColor(
                  stockHq[0]
                    ? stockHq[0].JieSuanZhangFu
                      ? stockHq[0].JieSuanZhangFu
                      : stockHq[0].ZhangFu
                    : 0
                )
              ]"
              >{{ stockHq[0] ? formatZhangFu(stockHq[0]) : '--' }}</span
            >
          </div>
          <!-- 添加数据 -->
          <div class="select-add" v-if="!addShow">
            <div class="stepper">
              <span class="label">持仓股数：</span>
              <van-stepper
                v-model="stockValue"
                step="100"
                integer
                :allow-empty="true"
                placeholder="请输入数量"
                default-value="0"
                @change="changeFunc1"
                max="99999999"
                min="0"
              />
            </div>
            <div class="btn-box">
              <van-button type="primary" @click="handleClickAdd">添加</van-button>
            </div>
          </div>
          <div v-else>
            <div class="add-hint">⚠️ 该股票已在您的持仓股列表中，您可继续增加或删减持仓股数</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 内容部分 (搜索内容/持股内容) -->
    <div class="mid" v-if="searchList.length === 0">
      <!-- 持股内容 -->
      <div class="my-stocks">
        <!-- 持股标题 -->
        <div class="stock-title">
          <div class="title-icon"></div>
          <div class="title-text">
            当前持仓股 <span class="title-span">({{ stockList.length }})</span>
          </div>
        </div>
        <van-loading v-if="stockLoading" style="text-align: center; margin-top: 20px" size="24px"
          >加载中...</van-loading
        >
        <div v-else>
          <!-- 持股列表 -->
          <div class="stock-list" v-if="stockList.length > 0">
            <van-row class="stock-list-title">
              <van-col span="10">
                <div class="list-title-text">名称/代码</div>
              </van-col>
              <van-col span="10">
                <div class="list-title-text text-right">持仓股数</div>
              </van-col>
              <van-col span="4"> </van-col>
            </van-row>

            <van-row
              class="stock-list-title align-center"
              type="flex"
              v-for="(itemStock, indexStock) in stockList"
              :key="indexStock"
              :ref="'code-' + itemStock.code"
              :class="itemStock.code == stockEdit ? 'flash-once' : ''"
            >
              <van-col span="10">
                <div class="list-stock">
                  <span class="stock-text" @click.stop="gotoStock(itemStock.code)">{{
                    itemStock.Hq ? itemStock.Hq.ZhongWenJianCheng : '--'
                  }}</span>
                  <span class="stock-code" @click.stop="gotoStock(itemStock.code)">{{
                    cleanStockCode(itemStock.code)
                  }}</span>
                </div>
              </van-col>
              <van-col span="10">
                <div class="stock-text text-right">
                  {{ itemStock.pos == 0 ? '--' : itemStock.pos }}
                </div>
              </van-col>
              <van-col span="4">
                <div class="stock-icon" v-if="$route.query.themeStyleVs == '2'">
                  <van-icon
                    :name="require('@/assets/image/hedging/edit-b.png')"
                    size="24"
                    @click.stop="editShowFunc(itemStock)"
                  />
                  <van-icon
                    :name="require('@/assets/image/hedging/del-b.png')"
                    size="24"
                    @click.stop="delPostionStockFunc(itemStock)"
                  />
                </div>
                <div class="stock-icon" v-else>
                  <van-icon
                    :name="require('@/assets/image/hedging/edit-w.png')"
                    size="24"
                    @click.stop="editShowFunc(itemStock)"
                  />
                  <van-icon
                    :name="require('@/assets/image/hedging/del-w.png')"
                    size="24"
                    @click.stop="delPostionStockFunc(itemStock)"
                  />
                </div>
              </van-col>
              <van-col span="24">
                <van-divider />
              </van-col>
            </van-row>
          </div>
          <!-- 空数据 -->
          <div v-else>
            <div class="empty-info">
              <!-- 空数据 -->
              <img src="@/assets/image/hedging/emptyData.png" alt="" class="empty-png" />
              <p class="empty-text">您还没有设置持仓股哦</p>
              <p class="empty-text2">添加持仓股，及时洞察相关数据</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 搜索结果部分 -->
    <div class="mid" v-else>
      <div
        class="search-list"
        v-for="(itemSearch, indexSearch) in searchList"
        :key="indexSearch"
        @click="selectStockFunc(itemSearch)"
      >
        <div class="search-title">{{ itemSearch.Name }}</div>
        <div class="search-code">
          <span class="code-leb">{{ itemSearch.Category }}</span
          >{{ cleanStockCode(itemSearch.Code) }}
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <van-dialog v-model="editShow" :showConfirmButton="false">
      <div class="edit-dialog">
        <div class="edit-title">
          {{ editStock.Hq ? editStock.Hq.ZhongWenJianCheng : '--'
          }}<span class="edit-title-span">{{
            editShow ? cleanStockCode(editStock.code) : ''
          }}</span>
        </div>
        <div class="edit-content">
          <span class="label">持仓股数：</span>
          <van-stepper
            v-model="stockValue2"
            step="100"
            integer
            :allow-empty="true"
            placeholder="请输入数量"
            default-value="0"
            @change="changeFunc2"
            max="99999999"
            min="0"
          />
        </div>
        <div class="edit-btn">
          <van-button plain class="edit-btn-info edit-btn-canel" @click.stop="editShow = false"
            >取消</van-button
          >
          <van-button plain class="edit-btn-info edit-btn-sub" @click.stop="editPostionStockFunc()"
            >确定</van-button
          >
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getPostionStocks, addPostionStock, getYunToken, delPostionStock } from '@/api/hedging.js';
import { searchJpb } from '@/api/index.js';
import Dzhyun from '@/utils/dzhyun.min.js';

import {
  judgeColor,
  toFixedNum,
  dateFormat,
  formatDateToStr,
  formatTimeToStr,
  cleanStockCode
} from '@/utils/format';

export default {
  // 组件名称
  name: 'postion',
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      reloadBtn:require('@/assets/image/reload.png'),
      reloadBtnBlock:require('@/assets/image/reload_block.png'),
      // 搜索内容
      searchValue: '',
      searchList: [],
      // 股票列表
      stockList: [],
      // 选中的股票信息
      selectStock: {},
      selectShow: false,
      addShow: false,
      //   持仓数量
      stockValue: '',
      //   行情信息
      stockHq: {},
      // 云Token
      yunToken: '',
      dzhyunObj: null,
      //   编辑弹窗
      editShow: false,
      // 弹窗进步器
      stockValue2: '',
      //   编辑的参数
      editStock: {},
      //   加载中
      stockLoading: true,
      // 编辑的股票代码
      stockEdit: ''
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {
    // searchValue(value) {
    //   var _this = this;
    //   searchJpb({ q: value })
    //     .then((result) => {
    //       _this.getShearchList(result.Data.Docs);
    //     })
    //     .catch((err) => {});
    // }
  },
  // 组件方法
  methods: {
    judgeColor,
    toFixedNum,
    cleanStockCode,
    // 获取我的持仓股票
    getPostionStocksFunc: function () {
      var _this = this;
      getPostionStocks({})
        .then((result) => {
          if (result.err == 200) {
            _this.stockList = result.data;
            _this.stockLoading = false;

            _this.scrollToItem();
          } else {
            _this.stockList = [];
            _this.stockLoading = false;
          }
        })
        .catch((err) => {
          _this.stockLoading = false;
        });
    },
    // 设置搜索的股票
    getShearchList: function (data) {
      var _this = this;
      _this.searchList = data;
    },
    // 选中搜索的股票
    selectStockFunc: function (item) {
      var _this = this;
      _this.searchValue = item.Name;
      _this.searchList = [];
      _this.selectStock = item;
      _this.closeWebSocket();
      _this.initWebSocket();

      if (
        _this.selectStock &&
        typeof _this.selectStock === 'object' &&
        !Array.isArray(_this.selectStock) &&
        Object.keys(_this.selectStock).length !== 0
      ) {
        // 显示选中
        _this.selectShow = true;
        // 判断 Symbol(股票代码) 是否存在我的持仓股中
        if (_this.stockList.length > 0) {
          _this.addShow = _this.stockList.some((item) => item.code === _this.selectStock.Symbol);
        } else {
          _this.addShow = false;
        }
      } else {
        // 隐藏选中
        _this.selectShow = false;
      }
    },
    // 添加股票
    handleClickAdd: function () {
      var _this = this;
      var params = {
        code: _this.selectStock.Symbol,
        pos: _this.stockValue
      };
      addPostionStock(params)
        .then((result) => {
          if (result.err == 200) {
            this.$toast({
              message: '添加成功',
              icon: require('@/assets/image/hedging/success.png')
            });
            // 添加成功
            _this.getPostionStocksFunc();
            // 初始化搜索
            _this.initSearchCond();
          } else {
            // 添加失败
            _this.$toast(result.msg);
          }
        })
        .catch((err) => {
          // 添加失败
          _this.$toast('添加失败!');
        });
    },
    // 触发搜索条件
    searchInput: function (value) {
      var _this = this;

      searchJpb({ q: _this.searchValue })
        .then((result) => {
          _this.getShearchList(result.Data.Docs);
        })
        .catch((err) => {});
    },
    // 初始化搜索条件
    initSearchCond: function () {
      var _this = this;
      _this.searchValue = '';
      _this.selectShow = false;
      _this.stockValue = '';
      _this.closeWebSocket();
    },
    // 获取云Token
    getYunTokenFunc: function () {
      var _this = this;
      var params = {
        appid: window.cloud.AppId,
        secret_key: window.cloud.SecretKey
      };
      getYunToken({})
        .then((result) => {
          if (result.err == 200) {
            _this.yunToken = result.data;
          }
        })
        .catch((err) => {});
    },
    // 初始化接入websocket
    initWebSocket: function () {
      var _this = this;
      this.dzhyunObj = new Dzhyun({
        address: window.cloud.WSUrl,
        dataType: 'json',
        token: _this.yunToken
      });
      _this.subscribe();
    },
    // 订阅股票信息
    subscribe: function () {
      var _this = this;
      // 获取获取的股票
      var codes = _this.selectStock.Symbol;
      _this.dzhyunObj.cancel();
      var indexsParams = {
        obj: codes,
        field: 'ZhongWenJianCheng,ZuiXinJia,ZhangFu,ZhangDie,JieSuanZhangDie,JieSuanZhangFu'
      };
      this.dzhyunObj.subscribe('/quote/stkdata', indexsParams, function (data) {
        _this.stockHq = data;
      });
    },
    // 关闭websocket
    closeWebSocket: function () {
      if (this.dzhyunObj !== null) {
        this.dzhyunObj.cancel();
      }
    },

    // 删除我的持仓股
    delPostionStockFunc: function (item) {
      var _this = this;
      this.$dialog
        .confirm({
          message: '确定要删除吗?'
        })
        .then(() => {
          delPostionStock({ code: item.code })
            .then((result) => {
              if (result.err == 200) {
                _this.$toast({
                  message: '删除成功',
                  icon: require('@/assets/image/hedging/success.png')
                });
                _this.getPostionStocksFunc();
              } else {
                _this.$toast('删除失败!');
              }
            })
            .catch((err) => {
              _this.$toast('删除失败!');
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 编辑股票
    editPostionStockFunc: function () {
      var _this = this;
      var params = {
        code: _this.editStock.code,
        pos: _this.stockValue2
      };
      addPostionStock(params)
        .then((result) => {
          if (result.err == 200) {
            this.$toast({
              message: '修改成功',
              icon: require('@/assets/image/hedging/success.png')
            });
            // 修改成功
            _this.getPostionStocksFunc();
            _this.editShow = false;
          } else {
            // 添加失败
            _this.$toast(result.msg);
          }
        })
        .catch((err) => {
          // 添加失败
          _this.$toast({
            message: '修改失败!'
          });
        });
    },
    // 请求编辑接口
    editShowFunc: function (item) {
      var _this = this;
      _this.editStock = item;
      _this.stockValue2 = item.pos == 0 ? '' : item.pos;
      _this.editShow = true;
    },
    // 点击减少置空
    changeFunc1: function () {
      var _this = this;
      if (_this.stockValue == 0) {
        _this.stockValue = '';
      }
    },
    changeFunc2: function () {
      var _this = this;
      if (_this.stockValue2 == 0) {
        _this.stockValue2 = '';
      }
    },
    // 跳转到股票分时
    gotoStock: function (stockCode) {
      window.location.href = `dzh_browser_url&goto=0&type=2970&code=${stockCode}&kind=1`;
    },
    // 编辑
    scrollToItem: function () {
      var _this = this;
      if (_this.stockEdit && _this.stockEdit !== '') {
        _this.$nextTick(() => {
          const targetEl = _this.$refs['code-' + _this.stockEdit];
          if (targetEl && targetEl[0]) {
            targetEl[0].$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => {
              _this.stockEdit = '';
            }, 3000);
          } else {
            _this.stockEdit = '';
          }
        });
      }
    },
    // 优化涨幅
    formatZhangFu: function (item) {
      // 判断如果存在
      if (item.JieSuanZhangFu) {
        return item.JieSuanZhangFu > 0 ? '+' + item.JieSuanZhangFu + '%' : item.JieSuanZhangFu;
      } else {
        return item.ZhangFu > 0 ? '+' + item.ZhangFu + '%' : item.ZhangFu;
      }
    },
    // 优化涨跌
    formatZhangDie: function (item) {
      if (item.JieSuanZhangDie) {
        return item.JieSuanZhangDie > 0 ? '+' + item.JieSuanZhangDie : item.JieSuanZhangDie;
      } else {
        return item.ZhangDie > 0 ? '+' + item.ZhangDie : item.ZhangDie;
      }
    },
    // 点击头部刷新
    reloadFn:function () {
      // 刷新页面
      location.href = 'dzh_browser_url&goto=0&screen=188';
    },
    // 点击关闭按钮
    closeFn:function () {
      this.needRefresh();
      // 关闭页面
      // location.href = 'dzh_browser_url&goto=0&screen=263';
    },
    // 刷新上一个页面
    needRefresh:function(){
      location.href = 'dzh_browser_url&goto=0&screen=390&needRefresh=webzqbx';
      setTimeout(() => {
        location.href = 'dzh_browser_url&goto=0&screen=263';
      }, 500);
    },
    // 注册大智慧JS
    registerDzhJs: function () {
      if (typeof DzhAppJs != 'undefined') {
        //  进行注册
        var data = {
          showClose:0,
          backFunction:'needRefreshInfo',
          disableScreen:'1'
        }
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('configWebview', JSON.stringify(data), '');
      }

    }
  },
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
   * 在实例初始化之后，组件属性计算之前，如data属性等
   */
  beforeCreate() {
    // document.title = '添加持仓股';
  },
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {
    var _this = this;
    window.needRefreshInfo = function () {
       _this.needRefresh();
    };

    this.stockEdit = this.$route.query.stock ? this.$route.query.stock : '';
    this.getPostionStocksFunc();
    // 获取云token
    this.getYunTokenFunc();
  },
  /**
   * 在挂载开始之前被调用：相关的 render 函数首次被调用。
   */
  beforeMount() {},
  /**
   * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
   */
  mounted() {
    // 注册大智慧JS
    this.registerDzhJs();
  },
  /**
   * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
   * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
   */
  beforeUpdate() {},
  /**
   * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
   * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
   */
  updated() {},
  /**
   * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
   */
  activated() {},
  /**
   * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
   */
  deactivated() {},
  /**
   * 实例销毁之前调用。在这一步，实例仍然完全可用。
   */
  beforeDestroy() {
    // 关闭socket
    this.closeWebSocket();
  },
  /**
   * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
   * 所有的事件监听器会被移除，所有的子实例也会被销毁。
   */
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--使用了scoped属性之后，父组件的style样式将不会渗透到子组件中，-->
<!--然而子组件的根节点元素会同时被设置了scoped的父css样式和设置了scoped的子css样式影响，-->
<!--这么设计的目的是父组件可以对子组件根元素进行布局。-->
<style scoped lang="less">
.content {
  //   height: 100vh;
  padding: 0 16px 16px 16px;

  ::v-deep{
    .van-sticky--fixed {
      margin: 0 16px;
    }
  }

  .top-nav {
    padding-top: 44px;
    background-color: #fff;
    .share_btn_box {
      width: 24px;
      height: 24px;
      position: absolute;
      top: 11px;
      right: 16px;
    }
    .van-hairline--bottom::after {
      display: none;
    }
  }

  .top-optipon {
    position: sticky;
    // top: 90px;
    top: 0px;
    background: #fff;
    z-index: 9;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  // 搜索
  .search-info {
    padding: 0;
    border: 1px solid #4d8cf9;
    border-radius: 6px;
    .van-search__content {
      padding: 12px 16px;
      border-radius: 6px;
      font-size: 15px;
      background-color: #fff;
      //   font-size: 15px;
      .van-cell {
        font-size: 15px;
      }
    }
    .search-img {
      width: 24px;
      height: 24px;
    }
  }

  .mid {
    .search-list {
      margin-top: 16px;
      margin-left: 6px;
      .search-title {
        font-weight: 500;
        color: #1d2129;
        font-size: 15px;
      }
      .search-code {
        color: #949da8;
        font-size: 12px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        align-items: center;
        justify-content: flex-start;
        .code-leb {
          background: #e9f0fe;
          border-radius: 4px;
          color: #286df7;
          font-size: 10px;
          margin-right: 4px;
          padding-left: 4px;
          padding-right: 4px;
        }
      }
    }
  }

  //   选中
  .select-conent {
    .select-hq {
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: flex-start;
      align-items: center;
      color: #4e5969;
      font-size: 14px;
      span {
        margin-right: 12px;
      }
    }
    .select-add {
      .stepper {
        margin-top: 30px;
        display: flex;
        align-items: center;
        .label {
          color: #4e5969;
          font-size: 14px;
          flex-shrink: 0;
          margin-right: 6px;
        }
        .van-stepper {
          display: flex;
          align-items: center;
          width: 100%;
          ::v-deep {
            .van-stepper__minus,
            .van-stepper__plus {
              width: 37px;
              height: 37px;
              background: #f2f3f5;
              border-radius: 6px;
              flex-shrink: 0;
              color: #286df7;
              font-size: 14px;
            }
            .van-stepper__input {
              height: 37px;
              background: #f2f3f5;
              border-radius: 6px;
              width: 100%;
              margin: 0 6px;
              color: #286df7;
            }
            .van-stepper__minus::before,
            .van-stepper__plus::before {
              width: 40%;
              height: 2px;
            }
            .van-stepper__minus::after,
            .van-stepper__plus::after {
              width: 2px;
              height: 40%;
            }
          }
        }
      }
      .btn-box {
        margin-top: 20px;
        .van-button--primary {
          height: 42px;
          border: 1px solid #286df7;
          background: #286df7;
          border-radius: 6px;
          font-weight: 500;
          color: #ffffff;
          font-size: 16px;
          width: 100%;
        }
      }
    }
    .add-hint {
      margin-top: 10px;
      color: #f45d58;
      font-size: 12px;
      text-align: left;
    }
  }

  // 我的持仓股内容
  .my-stocks {
    margin-top: 20px;
    .stock-title {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: flex-start;
      align-items: center;
      .title-icon {
        width: 3px;
        height: 10px;
        background: #286df7;
        border-radius: 88px;
        margin-right: 4px;
      }
      .title-text {
        font-size: 16px;
        color: #1d2129;
        font-weight: 600;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: flex-start;
        align-items: center;
        .title-span {
          color: #4e5969;
          font-size: 12px;
          font-weight: 400;
          margin-left: 4px;
        }
      }
    }
    // 股票列表
    .stock-list {
      .stock-list-title {
        margin-top: 10px;
        .list-title-text {
          color: #86909c;
          font-size: 12px;
        }
        .text-right {
          text-align: right;
          margin-right: 16px;
        }
        .list-stock {
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          align-content: flex-start;
          justify-content: center;
          align-items: flex-start;
        }
        .stock-text {
          font-weight: 500;
          color: #1d2129;
          font-size: 16px;
          margin-bottom: 2px;
        }
        .stock-code {
          color: #949da8;
          font-size: 13px;
        }
        .stock-icon {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-content: center;
          justify-content: space-between;
          align-items: center;
        }
        .van-divider {
          margin: 10px 0;
          border-color: #e5e5e5;
        }
      }
      .align-center {
        align-items: center;
      }
    }
    // 空数据
    .empty-info {
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: center;
      align-items: center;
      .empty-png {
        width: 90px;
        height: 77px;
        margin-top: 40px;
      }
      .empty-text {
        color: #1d2129;
        font-size: 15px;
        margin-top: 10px;
      }
      .empty-text2 {
        color: #8a929c;
        font-size: 12px;
        margin-top: 10px;
      }
    }
  }
  // 弹窗
  .edit-dialog {
    padding: 20px 16px;
    margin-top: 4px;
    .edit-title {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: flex-start;
      align-items: center;
      font-weight: 500;
      color: #1d2129;
      font-size: 17px;
      .edit-title-span {
        margin-left: 10px;
      }
    }
    .edit-content {
      margin: 20px 0;
      display: flex;
      align-items: center;
      .label {
        color: #4e5969;
        font-size: 14px;
        flex-shrink: 0;
        margin-right: 6px;
      }
      .van-stepper {
        display: flex;
        align-items: center;
        width: 100%;
        ::v-deep {
          .van-stepper__minus,
          .van-stepper__plus {
            width: 37px;
            height: 37px;
            background: #f2f3f5;
            border-radius: 6px;
            flex-shrink: 0;
            color: #286df7;
            font-size: 14px;
          }
          .van-stepper__input {
            height: 37px;
            background: #f2f3f5;
            border-radius: 6px;
            width: 100%;
            margin: 0 6px;
            color: #286df7;
          }
          .van-stepper__minus::before,
          .van-stepper__plus::before {
            width: 40%;
            height: 2px;
          }
          .van-stepper__minus::after,
          .van-stepper__plus::after {
            width: 2px;
            height: 40%;
          }
        }
      }
    }
    .edit-btn {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: space-between;
      align-items: center;
      .edit-btn-info {
        width: 48%;
        height: 38px;
        border-radius: 6px;
      }
      .edit-btn-canel {
        border: 1px solid #c9cdd4;
        color: #4e5969;
      }
      .edit-btn-sub {
        background: #286df7;
        border: 1px solid #286df7;
        color: #ffffff;
      }
    }
  }

  // 白板动画

  @-webkit-keyframes shake-bottom {
    0%,
    100% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
      -webkit-transform-origin: 50% 100%;
      transform-origin: 50% 100%;
    }
    10% {
      -webkit-transform: rotate(2deg);
      transform: rotate(2deg);
    }
    20%,
    40%,
    60% {
      -webkit-transform: rotate(-4deg);
      transform: rotate(-4deg);
    }
    30%,
    50%,
    70% {
      -webkit-transform: rotate(4deg);
      transform: rotate(4deg);
    }
    80% {
      -webkit-transform: rotate(-2deg);
      transform: rotate(-2deg);
    }
    90% {
      -webkit-transform: rotate(2deg);
      transform: rotate(2deg);
    }
  }
  @keyframes shake-bottom {
    0%,
    100% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
      -webkit-transform-origin: 50% 100%;
      transform-origin: 50% 100%;
    }
    10% {
      -webkit-transform: rotate(2deg);
      transform: rotate(2deg);
    }
    20%,
    40%,
    60% {
      -webkit-transform: rotate(-4deg);
      transform: rotate(-4deg);
    }
    30%,
    50%,
    70% {
      -webkit-transform: rotate(4deg);
      transform: rotate(4deg);
    }
    80% {
      -webkit-transform: rotate(-2deg);
      transform: rotate(-2deg);
    }
    90% {
      -webkit-transform: rotate(2deg);
      transform: rotate(2deg);
    }
  }

  .flash-once {
    -webkit-animation: shake-bottom 0.8s cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
    animation: shake-bottom 0.8s cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
  }
}

// 黑版样式
.black_theme {
  .top-nav {
    background-color: #1a1c26;
      .van-nav-bar {
        background-color: #1a1c26;
      }
      .van-nav-bar__title {
        color: #e4e9fe !important;
      }
  }
  .content {
    .top-optipon {
      background: #171922;
    }
    .search-info {
      .van-search__content {
        background-color: #171922;
      }
      ::v-deep {
        .van-field__control {
          color: #e4e9fe;
        }
      }
    }

    .mid {
      .search-list {
        .search-title {
          color: #e4e9fe;
        }
        .search-code {
          color: #6b7687;
          .code-leb {
            background: #16294e;
            color: #3b85fe;
          }
        }
      }
    }

    //   选中
    .select-conent {
      .select-hq {
        color: #aab9d1;
      }
      .select-add {
        .stepper {
          .label {
            color: #aab9d1;
          }
          .van-stepper {
            ::v-deep {
              .van-stepper__minus,
              .van-stepper__plus {
                background: #272935;
                color: #3b85fe;
              }
              .van-stepper__input {
                background: #272935;
                color: #3b85fe;
              }
            }
          }
        }
        .btn-box {
          .van-button--primary {
            background: #3b85fe;
            color: #ffffff;
          }
        }
      }
      .add-hint {
        color: #c62329;
      }
    }

    // 我的持仓股内容
    .my-stocks {
      .stock-title {
        .title-icon {
          background: #3b85fe;
        }
        .title-text {
          color: #e4e9fe;
          .title-span {
            color: #aab9d1;
          }
        }
      }
      // 股票列表
      .stock-list {
        .stock-list-title {
          .list-title-text {
            color: #86909c;
          }
          .stock-text {
            color: #e4e9fe;
          }
          .stock-code {
            color: #6b7687;
          }
          .van-divider {
            border-color: #282935;
          }
        }
      }
      // 空数据
      .empty-info {
        .empty-text {
          color: #e4e9fe;
        }
        .empty-text2 {
          color: #aab9d1;
        }
      }
    }

    // 弹窗
    .edit-dialog {
      .edit-title {
        color: #e4e9fe;
      }
      .edit-content {
        .label {
          color: #aab9d1;
        }
        .van-stepper {
          ::v-deep {
            .van-stepper__minus,
            .van-stepper__plus {
              background: #272935;
              color: #3b85fe;
            }
            .van-stepper__input {
              background: #272935;
              color: #3b85fe;
            }
          }
        }
      }
      .edit-btn {
        .edit-btn-canel {
          border: 1px solid #4e5969;
          color: #aab9d1;
        }
        .edit-btn-sub {
          background: #3b85fe;
          border: 1px solid #3b85fe;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
